/*      MyLogin - Authentication
 * All axios endpoints for Authentication in the MyLogin Application (Dara).
 */
import axios from 'axios'
import Cookies from 'js-cookie'
import { useAppStore } from '@/stores/app'
import type IOauthTokens from '@/models/Authentication/OauthTokens'
import type IUser from '@/models/User/User'
import type IUserProfile from '@/models/UserProfile/UserProfile'
import instance from '@/plugins/axios'

export default {
  getToken(params: object) {
    const appStore = useAppStore()
    const xsrfToken = Cookies.get('XSRF-TOKEN')
    const locale = localStorage.getItem('locale') || 'en'

    // Use plain axios to avoid deadlock: auth-refresh queues requests until refresh completes,
    // but the token request IS the refresh - it would wait for itself forever
    // we pass in locale as this standalone instance doesn't have the locale query param added by the request interceptor
    return axios
      .post<IOauthTokens>(
        `${appStore.config.AUTH_BASE_URL}/oauth/token-with-session`,
        params,
        {
          headers: { 'X-XSRF-TOKEN': xsrfToken },
          withCredentials: true,
          params: { locale },
        },
      )
      .then(r => r.data as IOauthTokens)
  },

  getLoggedInMyHQUser() {
    const appStore = useAppStore()

    return instance.get(`${appStore.config.AUTH_BASE_URL}/api/myhq-user`, { withCredentials: true })
  },

  getLoggedInMyHQUserShadow(shadowedOrganisationId: number) {
    const appStore = useAppStore()

    return instance.get<object, { user: IUser; user_profile: IUserProfile }>(
      `${appStore.config.AUTH_BASE_URL}/api/myhq-user-shadow`,
      { params: { shadowed_organisation_id: shadowedOrganisationId }, withCredentials: true })
  },
}
